import ContactFormFr from 'components/ContactUs/ContactFormFr'
import FooterFr from 'components/FooterFr'
import NavbarFr from 'components/NavbarFr'
import React from 'react'
import { useSelector } from 'react-redux';
import MobileNavbarFr from 'components/MobileNavbarFr';
import MobileFooterFr from 'components/MobileFooterFr';

function ContactUsFr() {
  const isMobile = useSelector(state=> state.windowSize.isMobile)
  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <ContactFormFr />
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <ContactFormFr />
      <FooterFr />
      </>
    )}
    </>
  )
}

export default ContactUsFr


